import $ from 'jquery';

import skipLinks from './utils/skipLinks';
import iframer from './utils/iframer';
import mNav from './utils/mNav';
import Nav from './utils/Nav';
import setupSearch from './utils/setupSearch';
// import desktopImages from './utils/desktopImages';
// import researchBrowser from './utils/researchBrowser';
import pixelateImage from './utils/pixelate';
import googleMaps from './utils/googleMaps';

function globals () {

    // iframe video in body content
    iframer();

    // Small Screen Navigation
    mNav();

    // Small Search
    setupSearch();

    // In page nav
    // trigger, triggerActive, target, targetActive
    Nav(
        '.m-nav--in-page .m-nav__heading .button',
        'button--active',
        '.m-nav--in-page .m-nav__list',
        'm-nav__list--open'
	);

    // Desktop Images
    // desktopImages();

    // Research Browser
    // researchBrowser();

    // Pixelate hero images
    //pixelateImage();

    // gmaps
    googleMaps();
}

$(function run () {
    console.log('ᕕ( ᐛ )ᕗ Running...');
    globals();
});
